(function () {
  'use strict';

  // List of known coupon extension identifiers + Microsoft Edge
  const blockedExtensions = [
    'honey',
    'joinhoney',
    'wikibuy',
    'capitaloneshopping',
    'rakuten',
    'ebates',
    'retailmenot',
    'piggy',
    'klarna',
    'coupert',
    'invisiblehand',
    'pouch',
    'cently',
    'genie',
    'smartcoupon',
    'edge-shopping',
    'edge-coupon',
    'edgeactions',
    'ms-editor',
    'msedge',
  ];

  // Detect and block extension injections
  function blockExtensionScripts() {
    // Remove injected scripts.
    // Third-party scripts can set element properties to non-string values
    // (via expando assignment or DOM named-access collisions when a form
    // contains an <input name="id">), so every string-typed DOM accessor
    // must be guarded — matching the guard already present at line ~176.
    document.querySelectorAll('script').forEach((script) => {
      const src = (typeof script.src === 'string' ? script.src : '').toLowerCase();
      const id = (typeof script.id === 'string' ? script.id : '').toLowerCase();
      const className = (
        typeof script.className === 'string' ? script.className : script.className?.baseVal || ''
      ).toLowerCase();

      blockedExtensions.forEach((ext) => {
        if (src.includes(ext) || id.includes(ext) || className.includes(ext)) {
          script.remove();
        }
      });
    });

    // Remove injected iframes
    document.querySelectorAll('iframe').forEach((iframe) => {
      const src = (typeof iframe.src === 'string' ? iframe.src : '').toLowerCase();
      const id = (typeof iframe.id === 'string' ? iframe.id : '').toLowerCase();

      blockedExtensions.forEach((ext) => {
        if (src.includes(ext) || id.includes(ext)) {
          iframe.remove();
        }
      });
    });

    // Remove injected divs and overlays
    document.querySelectorAll('div').forEach((div) => {
      const id = (typeof div.id === 'string' ? div.id : '').toLowerCase();
      const className = (
        typeof div.className === 'string' ? div.className : div.className?.baseVal || ''
      ).toLowerCase();

      blockedExtensions.forEach((ext) => {
        if (id.includes(ext) || className.includes(ext)) {
          div.remove();
        }
      });
    });
  }

  // Protect discount code input field - AGGRESSIVE CHROMIUM BROWSER BLOCKING
  function protectDiscountField() {
    // Restricted to <input>: every step below is HTMLInputElement-specific, and the
    // substring selectors match far more than checkout's code box — a <select
    // id="discount-codes-period"> or a <div class="discount-list"> matches just as
    // readily. Applying HTMLInputElement's value accessor to one of those makes every
    // later read of .value throw "Illegal invocation", which is what silently killed
    // the admin dashboard's whole advanced-metrics batch on its first line.
    const discountInputs = document.querySelectorAll(
      'input[name*="discount"], input[id*="discount"], input[class*="discount"], input[name*="coupon"], input[name*="promo"], input[placeholder*="coupon" i], input[placeholder*="discount" i], input[placeholder*="promo" i]'
    );

    discountInputs.forEach((input) => {
      // protectDiscountField may run again for late-injected markup; the value
      // accessor below is configurable, so re-defining it would otherwise stack.
      if (input.dataset.couponBlockerProtected === 'true') return;
      input.dataset.couponBlockerProtected = 'true';
      // CHROMIUM BROWSERS (Edge, Chrome, Brave, Opera, Vivaldi) BLOCKING
      // 1. Trick browsers into thinking this is a one-time code field (like 2FA)
      input.setAttribute('autocomplete', 'one-time-code');

      // 2. Disable all browser autofill/suggestions
      input.setAttribute('data-ms-editor', 'false'); // Edge
      input.setAttribute('data-ms-form-type', 'other'); // Edge
      input.setAttribute('data-lpignore', 'true'); // LastPass/browsers
      input.setAttribute('data-form-type', 'other'); // Generic
      input.setAttribute('data-autofill', 'false'); // Chrome/Chromium

      // 3. Make readonly until user clicks
      input.setAttribute('readonly', 'true');
      input.setAttribute('data-readonly-until-focus', 'true');

      // 4. Obfuscate field name to prevent browser detection
      const originalName = input.name;
      input.setAttribute('data-original-name', originalName);
      input.name = 'field_' + Math.random().toString(36).substr(2, 9);

      // 5. Add ARIA label to maintain accessibility (B13). Plus a hint span
      //    referenced via aria-describedby so screen readers explain the
      //    readonly-until-focus behaviour rather than just announcing
      //    "edit, read only" with no context. NVDA + JAWS read the
      //    description after the label; iOS VoiceOver reads it on focus.
      input.setAttribute('aria-label', 'Discount code');
      // Lazily create one shared hint span; reuse for every blocked input.
      let hintEl = document.getElementById('coupon-extension-blocker-hint');
      if (!hintEl) {
        hintEl = document.createElement('span');
        hintEl.id = 'coupon-extension-blocker-hint';
        hintEl.className = 'visually-hidden';
        hintEl.textContent =
          'This field unlocks when you tap or focus it. Keyboard and screen reader users can still enter a code.';
        document.body.appendChild(hintEl);
      }
      input.setAttribute('aria-describedby', 'coupon-extension-blocker-hint');

      // 6. Disable all suggestions and autocomplete
      input.setAttribute('spellcheck', 'false');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('autocapitalize', 'off');

      // Make editable on user click and restore original name
      input.addEventListener(
        'click',
        function () {
          this.removeAttribute('readonly');
          this.name = this.getAttribute('data-original-name') || originalName;
        },
        { once: false }
      );

      // Also enable on focus
      input.addEventListener('focus', function () {
        this.removeAttribute('readonly');
        this.name = this.getAttribute('data-original-name') || originalName;
      });

      // Detect and clear ANY autofilled values (extension or browser)
      input.addEventListener('input', function (e) {
        // If value changes without trusted user interaction
        if (!e.isTrusted) {
          console.warn('[CouponBlocker] Blocked untrusted input to discount field');
          this.value = '';
          return false;
        }
      });

      // Block Chromium autofill events
      input.addEventListener('autofill', function (e) {
        console.warn('[CouponBlocker] Blocked autofill event');
        e.preventDefault();
        e.stopPropagation();
        this.value = '';
        return false;
      });

      // Detect when browser adds 'autofilled' pseudo-class
      const checkAutofill = () => {
        if (input.matches(':-webkit-autofill') || input.matches(':autofill')) {
          console.warn('[CouponBlocker] Detected autofill state, clearing value');
          input.value = '';
        }
      };
      setInterval(checkAutofill, 100);

      // Block programmatic value changes
      const nativeValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
      Object.defineProperty(input, 'value', {
        configurable: true,
        set: function (val) {
          // Only allow if user is interacting
          if (document.activeElement === this) {
            nativeValue.set.call(this, val);
          } else {
            console.warn('[CouponBlocker] Blocked programmatic value change');
          }
        },
        get: function () {
          // Must be the native getter: invoking the setter here returned undefined
          // and wrote "undefined" into the field on every read.
          return nativeValue.get.call(this);
        },
      });
    });
  }

  // Monitor for dynamically injected content
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Element node
          const id = (typeof node.id === 'string' ? node.id : '').toLowerCase();
          const className = (
            typeof node.className === 'string' ? node.className : node.className?.baseVal || ''
          ).toLowerCase();

          blockedExtensions.forEach((ext) => {
            if (id.includes(ext) || className.includes(ext)) {
              node.remove();
            }
          });
        }
      });
    });
  });

  // Start monitoring
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      blockExtensionScripts();
      protectDiscountField();
    });
  } else {
    blockExtensionScripts();
    protectDiscountField();
  }

  // Run periodically to catch late injections
  setInterval(function () {
    blockExtensionScripts();
  }, 2000);
})();
